import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';
import Strong from '~/components/Strong';
import { formatPrice } from '~/Utils/format';
import { formatDate } from '~/Utils';

export default function ExtraRevenueView({ visible, onClose, extraRevenue, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const child = (text) => {
    if (text == null || text == '') {
      return <RedTimes />;
    }

    return <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>;
  };

  const childMobile = [
    {
      title: label('Informações'),
      dataIndex: 'summary',
      key: 'summary',
      render: (text, record) => (
        <div>
          <Strong>{t('Nome')}:</Strong> {record.name}
          <br />
          <Strong>{t('Preço')}:</Strong> {formatPrice(record.price)}
          <br />
          <Strong>{t('Data de aquisição')}:</Strong> {formatDate(record.acquired_at)}
          <br />
          <Strong>{t('Descrição')}:</Strong> {record.description}
          <br />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t('Informações')} - ${extraRevenue?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={
          isMobile
            ? childMobile
            : [
                { title: label('Nome'), dataIndex: 'name', render: child },
                { title: label('Preço'), dataIndex: 'price', render: (_, record) => child(formatPrice(record.price)) },
                {
                  title: label('Data de aquisição'),
                  dataIndex: 'acquired_at',
                  render: (_, record) => child(formatDate(record.acquired_at)),
                },
                { title: label('Descrição'), dataIndex: 'description', render: child },
              ]
        }
        dataSource={[extraRevenue]}
      />
    </Modal>
  );
}
